import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Plus } from 'lucide-react';

export function AssistantAddonCard({
  row,
  lineQty,
  primaryColor,
  onBumpQty,
  onAdd,
  testId,
}) {
  const rowTotal = row.price > 0 ? row.price * lineQty : 0;

  return (
    <Card className="p-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <h4 className="font-semibold text-sm">{row.name}</h4>
          <p className="text-xs text-muted-foreground mt-1 tabular-nums">
            {row.price > 0 ? (
              <>
                +${row.price.toLocaleString('es-CL')}
                {lineQty > 1 ? (
                  <span className="text-foreground font-medium">
                    {' '}
                    ×{lineQty} = ${rowTotal.toLocaleString('es-CL')}
                  </span>
                ) : null}
              </>
            ) : (
              'Sin cargo extra'
            )}
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2 shrink-0">
          <div className="flex items-center border rounded-md bg-background">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8 rounded-r-none"
              disabled={lineQty <= 1}
              onClick={() => onBumpQty(-1)}
              aria-label="Menos cantidad extra"
            >
              -
            </Button>
            <span className="text-sm tabular-nums w-8 text-center">{lineQty}</span>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8 rounded-l-none"
              disabled={lineQty >= 99}
              onClick={() => onBumpQty(1)}
              aria-label="Más cantidad extra"
            >
              +
            </Button>
          </div>
          <Button
            size="sm"
            style={{ backgroundColor: primaryColor }}
            className="text-white h-8 px-3"
            data-testid={testId}
            onClick={onAdd}
          >
            <Plus className="w-4 h-4 mr-1" />
            Agregar
          </Button>
        </div>
      </div>
    </Card>
  );
}
